import { css } from "@emotion/react"

import Image from "@p-ban/common/src/components/html/Image"
import Spacer from "@p-ban/common/src/components/layout/Spacer"

import btnFirst from "./btn_first.png"
import btnOrderData from "./btn_orderdatab.png"
import btnTools from "./btn_tools.png"
import btnSpec from "./btn_spec.png"

const LinkBanners = () => {
  return (
    <>
      <a href="/others/about_pban.html" css={styles.linkButton} aria-label="初めてのお客様へページへ移動">
        <Image src={btnFirst} alt="初めてのお客様へ" width={200} height={60} clearExtraSpace />
      </a>
      <Spacer size={10}/>
      <a href="/product/spec.html" css={styles.linkButton} aria-label="標準規格/仕様一覧ページへ移動">
        <Image src={btnSpec} alt="標準規格/仕様一覧" width={200} height={60} clearExtraSpace />
      </a>
      <Spacer size={10}/>
      <a href="/product/orderdata.html" css={styles.linkButton} aria-label="ご注文時に必要なデータ一覧ページへ移動">
        <Image src={btnOrderData} alt="ご注文時に必要なデータ一覧" width={200} height={60} clearExtraSpace />
      </a>
      <Spacer size={10}/>
      <a href="/services/tools.html" css={styles.linkButton} aria-label="便利ツールページへ移動">
        <Image src={btnTools} alt="便利ツール" width={200} height={60} clearExtraSpace />
      </a>
    </>
  )
}

export default LinkBanners

const styles = {
  linkButton: css`
    display: block;

    &:hover {
      opacity: 0.7;
    }
  `,
}
